/* eslint-disable jira/naming/disallow-filenames */
// eslint-disable-next-line jira/filename-case
import React from 'react';
import { ProjectCreateDrawerProvider } from '@jira/project-create__drawer-context/src/index.tsx';

import { CrossFlowProvider } from '@jira/growth__cross-flow/src/services/index.tsx';
import { FavoriteChangeProvider } from '@jira/platform__favouriting-favourite-change-provider/src/view/FavoriteChangeConsumer.tsx';

import { ModalContextProvider as JiraModalContextProvider } from '@jira/platform__entry-points-modal-context-provider/src/ModalContextProvider.tsx';
import { PostOfficeProvider } from '@jira/post-office__post-office-provider/src/index.tsx';
import { FlagsProvider } from '@atlaskit/flag/flag-provider';
// eslint-disable-next-line @atlaskit/design-system/use-spotlight-package
import SpotlightManager from '@atlaskit/onboarding/spotlight-manager';
import { useFlagService } from '@atlassian/jira-flags';
import type { ClientUiManagersProps } from './types.tsx';

export const ClientUiManagers = ({ children }: ClientUiManagersProps): React.JSX.Element => {
	const { showFlag } = useFlagService();

	return (
		<CrossFlowProvider>
			<PostOfficeProvider>
				<ProjectCreateDrawerProvider>
					<FavoriteChangeProvider onShowFlag={showFlag}>
						<SpotlightManager>
							<FlagsProvider>
								<JiraModalContextProvider>{children}</JiraModalContextProvider>
							</FlagsProvider>
						</SpotlightManager>
					</FavoriteChangeProvider>
				</ProjectCreateDrawerProvider>
			</PostOfficeProvider>
		</CrossFlowProvider>
	);
};
